import React, { useEffect, useState } from "react";
import api from "../../services/api";
import API_URL from "../../config";

import PageHeader from "../components/PageHeader";
import SearchBar from "../components/SearchBar";
import DataTable from "../components/DataTable";
import Loader from "../components/Loader";
import ConfirmModal from "../components/ConfirmModal";

const Applications = () => {

    const [loading, setLoading] = useState(true);

    const [applications, setApplications] = useState([]);

    const [filteredApplications, setFilteredApplications] = useState([]);

    const [search, setSearch] = useState("");

    const [selectedApplication, setSelectedApplication] = useState(null);

    const [deleteId, setDeleteId] = useState(null);

    useEffect(() => {

        fetchApplications();

    }, []);

    useEffect(() => {

        filterApplications();

    }, [applications, search]);

    const fetchApplications = async () => {

        try {

            setLoading(true);

            const response = await api.get("/admin/applications");

            setApplications(response.data.data || []);
            setFilteredApplications(response.data.data || []);

        } catch (error) {

            console.error("Error fetching applications:", error);

        } finally {

            setLoading(false);

        }

    };

    const filterApplications = () => {

        if (!search.trim()) {

            setFilteredApplications(applications);

            return;

        }

        const keyword = search.toLowerCase();

        const filtered = applications.filter((application) =>

            application.candidate_name?.toLowerCase().includes(keyword) ||

            application.job_title?.toLowerCase().includes(keyword) ||

            application.company_name?.toLowerCase().includes(keyword) ||

            application.application_status?.toLowerCase().includes(keyword)

        );

        setFilteredApplications(filtered);

    };

    const updateStatus = async (id, status) => {

        try {

            await api.put(

                `${API_URL}/admin/applications/${id}/status`,

                {
                    status
                }

            );

            fetchApplications();

        } catch (error) {

            console.error("Status update failed:", error);

        }

    };

    const handleDelete = async () => {

        if (!deleteId) return;

        try {

            await api.delete(

                `${API_URL}/admin/applications/${deleteId}`

            );

            fetchApplications();

        } catch (error) {

            console.error("Delete failed:", error);

        }

    };

    const columns = [

        {
            key: "id",
            label: "ID"
        },

        {
            key: "candidate_name",
            label: "Candidate"
        },

        {
            key: "company_name",
            label: "Company"
        },

        {
            key: "job_title",
            label: "Job"
        },

        {
            key: "application_status",
            label: "Status"
        },

        {
            key: "applied_date",
            label: "Applied On"
        }

    ];
        if (loading) {

        return (

            <Loader
                fullScreen={true}
                text="Loading Applications..."
            />

        );

    }

    return (

        <div className="space-y-6">

            <PageHeader

                title="Applications"

                subtitle="Manage all job applications"

                showButton={false}

                breadcrumb={[
                    {
                        label: "Dashboard",
                        link: "/admin"
                    },
                    {
                        label: "Applications"
                    }
                ]}

            />

            <div className="bg-white rounded-3xl shadow-lg p-6">

    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">

        <SearchBar
            value={search}
            onChange={setSearch}
            onClear={() => setSearch("")}
            placeholder="Search applications..."
        />

    </div>

    <DataTable
        title="Application List"
        columns={columns}
        data={filteredApplications}
        emptyMessage="No applications found."
        actions={(application) => (

            <div className="flex flex-wrap justify-center gap-2">

                <button
                    onClick={() => setSelectedApplication(application)}
                    className="px-3 py-2 rounded-xl bg-blue-100 text-blue-600 hover:bg-blue-200"
                >
                    View
                </button>

                <select
                    value={application.application_status}
                    onChange={(e) =>
                        updateStatus(
                            application.id,
                            e.target.value
                        )
                    }
                    className="rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
                >
                    <option>Applied</option>
                    <option>Shortlisted</option>
                    <option>Interview Scheduled</option>
                    <option>Selected</option>
                    <option>Rejected</option>
                </select>

                {application.resume_url && (

                    <a
                        href={application.resume_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="px-3 py-2 rounded-xl bg-green-600 text-white hover:bg-green-700"
                    >
                        Resume
                    </a>

                )}

                <button
                    onClick={() => setDeleteId(application.id)}
                    className="px-3 py-2 rounded-xl bg-red-100 text-red-600 hover:bg-red-200"
                >
                    Delete
                </button>

            </div>

        )}
    />

</div>

            <ConfirmModal
    open={deleteId !== null}
    title="Delete Application"
    message="Are you sure you want to delete this application?"
    confirmText="Delete"
    onConfirm={() => {
        handleDelete();
        setDeleteId(null);
    }}
    onCancel={() => setDeleteId(null)}
/>
                    {selectedApplication && (

<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 overflow-auto">

<div className="bg-white rounded-3xl shadow-2xl w-full max-w-6xl p-8 my-10">

<div className="flex justify-between items-center mb-8">

<h2 className="text-2xl font-bold">
Application Details
</h2>

<button
onClick={() => setSelectedApplication(null)}
className="text-2xl text-gray-500 hover:text-red-500"
>
✕
</button>

</div>

<h3 className="text-xl font-semibold mb-4 border-b pb-2">
Candidate Information
</h3>

<div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">

<Detail label="Name" value={selectedApplication.candidate_name} />
<Detail label="Email" value={selectedApplication.candidate_email} />
<Detail label="Phone" value={selectedApplication.candidate_phone} />
<Detail label="Qualification" value={selectedApplication.qualification} />
<Detail label="Experience" value={selectedApplication.experience_years} />
<Detail label="Skills" value={selectedApplication.skills} />

</div>

<h3 className="text-xl font-semibold mb-4 border-b pb-2">
Company Information
</h3>

<div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">

<Detail label="Company" value={selectedApplication.company_name} />
<Detail label="Recruiter" value={selectedApplication.recruiter_name} />
<Detail label="Email" value={selectedApplication.recruiter_email} />
<Detail label="Phone" value={selectedApplication.recruiter_phone} />

</div>

<h3 className="text-xl font-semibold mb-4 border-b pb-2">
Job Information
</h3>

<div className="grid grid-cols-1 md:grid-cols-2 gap-6">

<Detail label="Job Title" value={selectedApplication.job_title} />
<Detail label="Location" value={selectedApplication.location} />
<Detail label="Job Type" value={selectedApplication.job_type} />
<Detail label="Salary" value={selectedApplication.salary} />
<Detail label="Applied Date" value={selectedApplication.applied_date} />
<Detail label="Status" value={selectedApplication.status} />

<div className="md:col-span-2">

<p className="text-sm text-gray-500 mb-2">
Resume
</p>

{selectedApplication.resume_url ? (

<a
href={selectedApplication.resume_url}
target="_blank"
rel="noopener noreferrer"
className="inline-block px-4 py-2 rounded-xl bg-green-600 text-white hover:bg-green-700"
>
Download Resume
</a>

) : (

<p className="text-gray-500">
Resume not uploaded
</p>

)}

</div>

</div>

<div className="flex justify-end mt-10">

<button
onClick={() => setSelectedApplication(null)}
className="px-6 py-2 rounded-xl bg-gray-200 hover:bg-gray-300"
>
Close
</button>

</div>

</div>

</div>

)}
                </div>

    );

};
const Detail = ({ label, value }) => (
    <div>
        <p className="text-sm text-gray-500">{label}</p>
        <p className="font-semibold text-gray-800">
            {value || "-"}
        </p>
    </div>
);

export default Applications;